<template>    
    <div class="pregunta-container row justify-content-center" v-if="pregunta">
      <div class="col-12 col-md-12">
          <h5 class="pregunta-subcategory">{{ pregunta.subcategory }}</h5>
          <h4 class="pregunta-pregunta">{{ pregunta.pregunta }}</h4>
          <BarChart 
            v-if="!pregunta.type"
            class="pregunta-respuestas"
            :lista_encuestas="lista_options(pregunta.id)"
            :pregunta-parent="pregunta"
          />
          <BarStacked
            v-if="pregunta.type==`stacked`"
            class="pregunta-respuestas"
            :lista_encuestas="lista_options(pregunta.id)"
            :pregunta-parent="pregunta"
          />
          <barChartFaces
            v-if="pregunta.type=='barChartFaces'"
            class="pregunta-respuestas"
            :partyData="partyData(pregunta.id)"
            :noParty="noPartyData(pregunta.id)"
            :data="lista_options(pregunta.id)"
            :pregunta-parent="pregunta"
          />          
          <barVerticalChart
            v-if="pregunta.type=='verticalChart'"
            class="pregunta-respuestas"
            :data="partyData(pregunta.id)"
            :noParty="noPartyData(pregunta.id)"
            :pregunta-parent="pregunta"
          />

          <barChartGroup
          v-if="pregunta.type=='barChartGroup'"
          class="pregunta-respuestas"
          :data="lista_options(pregunta.id)"
          :pregunta-parent="pregunta"
        />

          <barChartStackedGroup
          v-if="pregunta.type=='barChartStackedGroup'"
          class="pregunta-respuestas"
          :data="lista_options(pregunta.id)"
          :pregunta-parent="pregunta"
        />
      </div>      
      <div class="col-12 col-md-12 d-block d-md-none p-0">
       <div class="footer-container">
          <div class="">
            <SocialSharing />
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 p-0">
       <div class="footer-container">
        <a target="_parent" href="https://www.elnuevodia.com/especiales/la-encuesta-el-nuevo-dia-2023/">
          <img src="@/assets/logo-encuesta.png" height="25px" />
        </a>
        <a class="btn-link" target="_parent" href="https://www.elnuevodia.com/especiales/la-encuesta-el-nuevo-dia-2023/">Ver todos los resultados</a>
       </div>
      </div>
    </div>     
</template>


<script>

import { mapState } from 'vuex'
import { filter, orderBy  } from 'lodash'
import BarChart from '@/components/BarChart'
import BarStacked from '@/components/BarStacked'
import barChartFaces from '@/components/barChartFaces'
import barVerticalChart from '@/components/barVerticalChart'
import barChartGroup from '@/components/barChartGroup'
import barChartStackedGroup from '@/components/barChartStackedGroup'
import SocialSharing from '@/components/SocialSharing'

export default {
  name: 'SinglePregunta',
  components: {
    BarChart,    
    BarStacked,
    barChartFaces,
    barVerticalChart,
    barChartGroup,
    barChartStackedGroup,
    SocialSharing
  },
  props: {
    pregunta: {
      type: [Object, Array]
    }
  },
  computed: {
    ...mapState({
      data_encuestas: state => state.encuesta.data_encuestas,     
    })
  },
  methods: {
    lista_options(id) {
    return orderBy(filter(this.data_encuestas,["question_id",id]), ['date_one'], ['desc'])
    },
    partyData(id) {
        let filteredData = filter(this.data_encuestas, (item) => {
          if(item.question_id == id && item.partido != "") {
            return item
          }
        })
        return orderBy(filteredData, ['date_one'], ['desc'])
    },
    noPartyData(id) {
        let filteredData = filter(this.data_encuestas, (item) => {
          if(item.question_id == id && item.partido == "") {
            return item
          }
        })
        return orderBy(filteredData, ['date_one'], ['desc'])
    },    
  }
}
</script>